// app/features/industry-workflows/components/IndustryWorkflowListComponent.tsx
'use client';

import { IndustryWorkflowListItem } from '../industry-workflow.interface';
import { useIndustryWorkflowsHook } from '../services_and_hooks/useIndustryWorkflowsHook';
import { IndustryWorkflowCardComponent } from './IndustryWorkflowCardComponent';

interface Props {
  industryId?: string;
  limit?: number;
}

export function IndustryWorkflowListComponent({ industryId, limit = 20 }: Props) {
  // "One Line to Rule Them All" - Blueprint pattern
  const { workflows, isLoading, isError } = useIndustryWorkflowsHook({
    industry_id: industryId,
    limit
  });

  if (isLoading) {
    return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {[...Array(6)].map((_, i) => (
        <div key={i} className="h-64 bg-gray-100 animate-pulse rounded-lg" />
      ))}
    </div>;
  }

  if (isError || workflows.length === 0) {
    return <div className="text-center py-12">
      <p className="text-gray-600">No workflows found</p>
    </div>;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {workflows.map((workflow: IndustryWorkflowListItem) => (
        <IndustryWorkflowCardComponent key={workflow.id} workflow={workflow} />
      ))}
    </div>
  );
}

